<template>
  <div class="news-warp">
    <adv-item adv-postion-name="column_information_top_0" />
    <Listbox props-titile="校园动态">
      <module-title title="校园动态列表" class="module-title" type-title="inside" />
      <el-tabs v-model="activeName" class="tabsNews" @tab-click="handleLoad">
        <el-tab-pane key="all" label="全部" name="all">
          <TabList v-if="activeName==='all'" :props-data="data" />
        </el-tab-pane>
        <el-tab-pane v-for="item in optionsType" :key="item.id" :label="item.classifyName" :name="item.id">
          <TabList v-if="data.classifyId && activeName===item.id" :props-data="data" />
        </el-tab-pane>
      </el-tabs>
    </Listbox>
    <adv-item adv-postion-name="column_information_bottom_0" />
  </div>
</template>
<script>
import Listbox from '@/views/common/listbox';
import TabList from '@/views/news/tabList';
// 获取API
import getContent from '@/api/content';
export default {
  name: 'News',
  components: {
    Listbox,
    TabList
  },
  data: () => {
    return {
      optionsType: [],
      activeName: '',
      data: {
        interface: {
          list: 'getSchoolnewsList'
        },
        classifyId: '',
        source: 'schoolnews'
      }
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.activeName = route.params.id === 'all' ? 'all' : route.params.id;
        this.data.classifyId = route.params.id === 'all' ? '' : route.params.id;
        this.getTypeAll();
      },
      immediate: true
    }
  },
  methods: {
    // 获取全部分类
    getTypeAll() {
      getContent['getSchoolnewsClassifys']()
        .then(res => {
          if (res.data === null || res.data === '' || res.data === 'undefind') {
            this.optionsType = [];
          } else {
            this.optionsType = res.data;
          }
        });
    },
    // Tab切换
    handleLoad(val) {
      this.data.classifyId = val.name === 'all' ? '' : val.name;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.news-warp{
  .news-container{
    background-color: #f0f2f5;
    margin-top: 20px;
  }
  .resoure{
    .box-card{
      margin: 10px 0;
    }
  }
  .breadcrumb{
    padding: 20px 0;
  }

  .news-item{
    border-bottom: #f3f3f3 solid 1px;
    padding: 12px 0;
  }
  .message-main{
      .title{
        font-size: 16px;
      }
      .text{
        margin-top: 10px;
        line-height: 22px;
        width: 100%;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
      }
    }
}

</style>
